import { Row, Col, Form } from "react-bootstrap";
import { useImperativeHandle, forwardRef, useState, useEffect } from "react";
import defaultimg from "../../icons/noimage.png";
import { Action, Status } from "../utility/common/constants/CommonConstants"
import { SingleInput } from "../utility/forms/inputs/InputsTransaction";
import { isAllowCustomSpecialCharacters, isAlphanumericWithPlusAmpersandEqualsPercentMinus } from "../../functions/validations";
import { AddNewGrooveWPQ } from "../../Services/wpq_groove-services";
import {updateDetailsLastWeldDate, getRecentLastWeldDate} from "../../Services/wpq_details-service";
import { calculateWPQExpiryDate } from "./WPQObjects/WPQ_common";
import { getPresignedURL } from "../../Services/Welder-services";
import { IsUserMasterBand, getAllUserMaster } from "../../Services/user-service";
import { WPQHeader } from "./WPQObjects/WPQHeader";
import { PQRPage3TableColumnN, WPQPage3Table3observation, PQRPage3TableColumnNindex } from "../utility/common/TransactionComponents/WPQ_PQR_Test_Table_Components";
import { UpdateWPQDetailComplete, check_TestArray, check_MinimumLeakPath, check_MacroMicroTest } from "./WPQObjects/WPQ_Validations";
import { WPQ_tubePage1, WPQ_tubePage3, WPQ_tubePage4, WPQ_tubesheet_page2, WPQ_Tube_Page2, WPQ_tubePage4_Header } from "./WPQObjects/WPQ_entity";
import { emptyError, handleCount } from "./WPQObjects/WPQCommonUtils";
import { validateForm, validateDetailArrays, handleChangeNotesFlexible } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import { handleWPQGeneralSubmit, handleWPQGeneralSubmitTemp } from "../utility/common/TransactionComponents/TransactionSubmitUtils";
import { UnifiedSignatureSection } from "../utility/common/TransactionComponents/UnifiedSignatureSection";
import { showWarning } from "../utility/ui/notifications/Toaster";
import PropTypes from "prop-types";
import { DotLoader } from "react-spinners";

const WPQ_Tubesheet_Page4 = forwardRef(
  ({ headerObj, setheaderObj, detailObj, setdetailObj, isDisabled,
    isReadonly, action,
    setAction }, ref) => {
    WPQ_Tubesheet_Page4.propTypes = {
      headerObj: PropTypes.array,
      setheaderObj: PropTypes.func,
      setdetailObj: PropTypes.func,
      isDisabled: PropTypes.bool,
      isReadonly: PropTypes.bool,
      action: PropTypes.string,
      setAction: PropTypes.func,
      detailObj: PropTypes.array
    };

    const avatar = { defaultimg };
    const [users, setUsers] = useState(null);
    let Band = sessionStorage.getItem("Band");
    let folderwld = "wld_signatures";
    const [IsEdited, setIsEdited] = useState(false);
    const [loading, setLoading] = useState(false);
    const [previewuser, setPreviewuser] = useState(avatar.defaultimg);
    const [previewapproved, setPreviewapproved] = useState(avatar.defaultimg);
    let Radiography_Test = detailObj?.Radiography_Test;
    let Other_Test = detailObj?.Other_Test;
    let object = detailObj?.Minimum_Leak_Path;
    let Minimum_Leak_Path5 = detailObj?.Minimum_Leak_Path5;
    let array = { ...object };
    let element = array[0];
    let data = { ...element };
    let Table1 = data.Table1;
    let Table2 = data.Table2;
    let Minimum_Leak_Path1 = Table1;
    let Minimum_Leak_Path2 = Table2;

    const fetchUserMaster = async () => {
      const result = await getAllUserMaster();
      const active = result.filter((item) => item.um_status === "Active");
      setUsers(active);
    };

    useEffect(() => {
      fetchUserMaster();
    }, []);

    const [error, setError] = useState({
      WPQ_Radio_TubeNo: {},
      WPQ_Radio_Acceptance_Criteria: {},
      WPQ_Radio_Observation: {},
      WPQ_Radio_Results: {},

      WPQ_OT_TypeofTest: {},
      WPQ_OT_Acceptance_Criteria: {},
      WPQ_OT_Observation: {},
      WPQ_OT_Results: {},

      WPQ_MLP_Tube_No: {},
      WPQ_MLP_LocA: {},
      WPQ_MLP_LocB: {},
      WPQ_MLP_LocC: {},
      WPQ_MLP_LocD: {},

      WPQ_MLP_Tube_No1: {},
      WPQ_MLP_LocA1: {},
      WPQ_MLP_LocB1: {},
      WPQ_MLP_LocC1: {},
      WPQ_MLP_LocD1: {},

      WPQ_MLP_Tube_No2: {},
      WPQ_MLP_LocA2: {},
      WPQ_MLP_LocB2: {},
      WPQ_MLP_LocC2: {},
      WPQ_MLP_LocD2: {},

      WPQ_MLP_Tube_No3: {},
      WPQ_MLP_LocA3: {},
      WPQ_MLP_LocB3: {},
      WPQ_MLP_LocC3: {},
      WPQ_MLP_LocD3: {},

      WPQ_MLP_Magnification: {},
      WPQ_MLP_Acceptance_Criteria: {},
      WPQ_MLP_Observation: {},

      WPSH_PWHeatTre_Temperature: {},

      WPQ_Radio_Notes: {},
      WPQ_OT_Notes: {},

      WPQ_MLP_Result: {},

      WPSH_PreparedBy_Name: {},
      WPSH_PreparedBy_Date: {},
      WPSH_PreparedBy_Remark: {},

      WPSH_ApprovedBy_Name: {},
      WPSH_ApprovedBy_Date: {},
      WPSH_Approval_Status: {},
      WPSH_ApprovedBy_Remark: {},
      WPQ_Wps_RecordNo: {},
    });

    const validate = async () => {
      let temperror = emptyError(error, setError, false);

      // 1. Use common validation for simple fields
      const combinedObj = { ...detailObj, ...headerObj };
      const requiredFields = { ...WPQ_tubePage1, ...WPQ_Tube_Page2, ...WPQ_tubePage3, ...WPQ_tubePage4_Header, ...WPQ_tubePage4 };

      const validationResult = validateForm({
        headerObj: combinedObj,
        detailObj,
        requiredFields: requiredFields,
        detailConfig: [], // Empty - no array validation here
        currentErrors: error,
      });

      let isError = validationResult.isError;
      let finalErrors = validationResult.errors;

      // 2. Custom validation for signatures
      if (!headerObj.WPSH_PreparedBy_Name) {
        isError = true;
        finalErrors.WPSH_PreparedBy_Name = { status: true, message: "This field is required" };
      }
      if (!headerObj.WPSH_ApprovedBy_Name) {
        isError = true;
        finalErrors.WPSH_ApprovedBy_Name = { status: true, message: "This field is required" };
      }

      // Band-specific validation
      if (Band === "T" || Band === "P") {
        if (headerObj?.WPSH_ApprovedBy_Remark === "") {
          isError = true;
          finalErrors.WPSH_ApprovedBy_Remark = { status: true, message: "This field is required" };
        }
      }

      // 3. Custom validation for test arrays - only validate, don't set UI errors
      if (check_TestArray(Radiography_Test, ["WPQ_Radio_TubeNo", "WPQ_Radio_Acceptance_Criteria", "WPQ_Radio_Observation", "WPQ_Radio_Results"], 2)) {
        isError = true;
      }

      if (check_TestArray(Other_Test, ["WPQ_OT_TypeofTest", "WPQ_OT_Acceptance_Criteria", "WPQ_OT_Observation", "WPQ_OT_Results"], 2)) {
        isError = true;
      }

      if (check_MacroMicroTest(Minimum_Leak_Path1, ["WPQ_MLP_Tube_No", "WPQ_MLP_LocA", "WPQ_MLP_LocB", "WPQ_MLP_LocC", "WPQ_MLP_LocD"], 4)) {
        isError = true;
      }

      if (check_MinimumLeakPath(Minimum_Leak_Path5, ["WPQ_MLP_Magnification", "WPQ_MLP_Acceptance_Criteria"], 2)) {
        isError = true;
      }

      // 4. Custom validation for Value_A/Value_B array fields (from page 2)
      const detailValidation = validateDetailArrays(detailObj, WPQ_tubesheet_page2, finalErrors, setError);
      if (detailValidation.isError) {
        isError = true;
        finalErrors = detailValidation.errors;
      }

      // 5. Apply all errors at once
      setError(finalErrors);

      return { isError, temperror };
    };



    // Sync last weld date before submission
    const syncLastWeldDate = async () => {
      if (headerObj?.WPQ_Date && detailObj?.WPQD_WP_Type) {
        console.log("🔄 FINAL SYNC: Applying recent date logic before submission");
        const [year, month, day] = headerObj.WPQ_Date.split("-");
        const detailDateFormat = `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
        const isToday = new Date(parseInt(year), parseInt(month) - 1, parseInt(day)).setHours(0,0,0,0) === new Date().setHours(0,0,0,0);
        
        if (!isToday && detailObj?.WPQD_WP_Type) {
          try {
            const processCategory = `GTAW#${detailObj.WPQD_WP_Type}`;
            const recentDate = await getRecentLastWeldDate({
              WPQ_WelderId: headerObj.WPQ_WelderId,
              WPQ_Process_Category: processCategory,
              WPSH_Status: "Approved"
            });
            
            if (recentDate) {
              const selectedDateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
              const [recentDay, recentMonth, recentYear] = recentDate.split("-");
              const recentDateObj = new Date(parseInt(recentYear), parseInt(recentMonth) - 1, parseInt(recentDay));
              
              const finalLastWeldDate = selectedDateObj >= recentDateObj ? detailDateFormat : recentDate;
              const updatedDetailObj = {
                ...detailObj,
                wld_createdon: finalLastWeldDate,
                WPQ_Welder_ExpiresOn: calculateWPQExpiryDate(finalLastWeldDate)
              };
              setdetailObj(updatedDetailObj);
              console.log(`📊 SUBMIT SYNC: Selected: ${detailDateFormat}, Recent: ${recentDate}, Using: ${finalLastWeldDate}`);
              return updatedDetailObj;
            }
          } catch (error) {
            console.warn("⚠️ Submit: Could not fetch recent date, using current date");
          }
        }
      }
      return detailObj;
    };

    const handleAdd = async (approvalstatus) => {
      detailObj = await syncLastWeldDate();
      
      let result = false;
      if (
        headerObj?.WPSH_Status === Status.StatusApproved ||
        headerObj?.WPSH_Status === Status.StatusRejected
      ) {
        headerObj.WPSH_Status = Status.StatusPending;
        if (headerObj?.WPSH_Status === Status.StatusApproved) handleCount();
      }

      if (
        headerObj?.WPSH_Approval_Status !== undefined
      )
        headerObj.WPSH_Status = headerObj?.WPSH_Approval_Status;
      else headerObj.WPSH_Status = approvalstatus;

      let Radio = {
        wld_createdon: detailObj.wld_createdon || "",
        WPQ_WelderId: detailObj.WPQ_WelderId,
        WPQ_RecordNo: detailObj.WPQ_RecordNo,
        WPSH_Status: headerObj.WPSH_Status,
        WPQ_Process: detailObj.WPQ_Process,
        WPSD_FM_SFA: detailObj.WPSD_FM_SFA,
        wld_process_status: detailObj.wld_process_status,
        WPQ_Radio_Notes: detailObj.WPQ_Radio_Notes,
        Radiography_Test: detailObj.Radiography_Test,
      };

      let Other = {
        wld_createdon: detailObj.wld_createdon || "",
        WPQ_WelderId: detailObj.WPQ_WelderId,
        WPQ_RecordNo: detailObj.WPQ_RecordNo,
        WPSH_Status: headerObj.WPSH_Status,
        WPQ_Process: detailObj.WPQ_Process,
        WPSD_FM_SFA: detailObj.WPSD_FM_SFA,
        wld_process_status: detailObj.wld_process_status,
        WPQ_OT_Notes: detailObj.WPQ_OT_Notes,
        Other_Test: detailObj.Other_Test,
      };

      let Minimum_Leak_PathArray = [
        {
          Table1: Minimum_Leak_Path1,
          Table2: Minimum_Leak_Path2,
        },
      ];

      let MacroEx = {
        wld_createdon: detailObj.wld_createdon || "",
        WPQ_WelderId: detailObj.WPQ_WelderId,
        WPQ_RecordNo: detailObj.WPQ_RecordNo,
        WPSH_Status: headerObj.WPSH_Status,
        WPQ_Process: detailObj.WPQ_Process,
        WPSD_FM_SFA: detailObj.WPSD_FM_SFA,
        wld_process_status: detailObj.wld_process_status,
        WPQ_MLP_Result: detailObj.WPQ_MLP_Result,
        Minimum_Leak_Path: Minimum_Leak_PathArray,
      };
      let MacroEx5 = {
        wld_createdon: detailObj.wld_createdon || "",
        WPQ_WelderId: detailObj.WPQ_WelderId,
        WPQ_RecordNo: detailObj.WPQ_RecordNo,
        WPSH_Status: headerObj.WPSH_Status,
        WPQ_Process: detailObj.WPQ_Process,
        WPSD_FM_SFA: detailObj.WPSD_FM_SFA,
        wld_process_status: detailObj.wld_process_status,
        WPQ_MLP_Result: detailObj.WPQ_MLP_Result,
        WPQ_MLP_Observation: detailObj.WPQ_MLP_Observation,
        Minimum_Leak_Path5: detailObj.Minimum_Leak_Path5,
      };
      const postList = [MacroEx, Radio, Other, MacroEx5];
      let res = await AddNewGrooveWPQ(headerObj);
      let resdet = await UpdateWPQDetailComplete(postList);

      if (res !== undefined && resdet !== "SpecialCharacters") {
        if(headerObj.WPSH_Status === Status.StatusApproved){
        let updateDateResult = await updateDetailsLastWeldDate(detailObj);
        }
        result = true;
        setAction(Action.ActionEdit);
      } else {
        showWarning(process.env.REACT_APP_SPECIAL_CHARACTER_MSG);
      }
      return result;
    };

    useEffect(() => { }, [IsEdited]);

    const validateTemp = async () => {
      let isError = false;
      let temperror = emptyError(error, setError, isError);
      return { isError, temperror };
    };

    const handleSubmitTemp = () => handleWPQGeneralSubmitTemp(IsEdited, validateTemp, () => handleAdd(headerObj?.WPSH_Status), setLoading, setIsEdited, headerObj?.WPQH_Status || Status.StatusTempSaved);

    const handleSubmit = () => handleWPQGeneralSubmit(() => validate(), () => handleAdd(Status.StatusPending), setLoading, setIsEdited, Status.StatusPending);

    useImperativeHandle(ref, () => ({
      funcOnNext4: async () => {
        return await handleSubmit();
      },

      funcOnNextTemp4: async () => {
        return await handleSubmitTemp();
      },
    }));

    const fetchbyuserprofile = async (userprofile) => {
      try {
        if (userprofile !== "") {
          const result = await getPresignedURL(folderwld, userprofile);
          const geturl = result.url;
          setPreviewuser(geturl);
        } else {
          setPreviewuser(avatar.defaultimg);
        }
      } catch (error) {
        if (error.request) {
          console.log(error.request);
        } else {
          console.log(`Error: ${error.message}`);
        }
      }
    };

    const fetchapproveUserProfile = async (userprofile) => {
      try {
        if (userprofile !== "") {
          const result = await getPresignedURL(folderwld, userprofile);
          const geturl = result.url;
          setPreviewapproved(geturl);
        } else {
          setPreviewapproved(avatar.defaultimg);
        }
      } catch (error) {
        if (error.request) {
          console.log(error.request);
        } else {
          console.log(`Error: ${error.message}`);
        }
      }
    };

    useEffect(() => {
      if (
        (action === Action.ActionEdit || action === Action.ActionCopy) &&
        headerObj?.wpq_signaturePrepared !== ""
      ) {
        fetchbyuserprofile(headerObj?.wpq_signaturePrepared);
      }

      if (
        (action === Action.ActionEdit || action === Action.ActionCopy) &&
        headerObj?.wpq_signatureApproved !== ""
      ) {
        fetchapproveUserProfile(headerObj?.wpq_signatureApproved);
      }
    }, []);

    const handleChange = (e) => {
      setIsEdited(true);
      const { name, value } = e.target;

      setheaderObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const handleChangeRadio = async (e) => {
      setIsEdited(true);

      // Call validation and check the isError property
      const validationResult = await validate();

      if (validationResult.isError) {
        showWarning("Cannot Approve or Reject the Record, Please Fill Required Fields of all 4 Pages.");
      } else {
        const { name, value } = e.target;
        setheaderObj((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    };

    const handleChangetestarray = (Index, key, newValue) => {
      setIsEdited(true);
      const updatedheadertestObj = { ...detailObj };

      updatedheadertestObj.Radiography_Test[Index][key] = newValue;
      setdetailObj(updatedheadertestObj);
    };

    const handleChangeOther_Testarray = (Index, key, newValue) => {
      setIsEdited(true);
      const updatedheadertestObj = { ...detailObj };

      updatedheadertestObj.Other_Test[Index][key] = newValue;
      setdetailObj(updatedheadertestObj);
    };

    const handleChangeMinimum_Leak_Patharray5 = (
      Index,
      key,
      table,
      newValue
    ) => {
      setIsEdited(true);
      const updatedheadertestObj = { ...detailObj };

      updatedheadertestObj.Minimum_Leak_Path5[Index][key] = newValue;
      setdetailObj(updatedheadertestObj);
    };
    const handleChangeMinimum_Leak_Patharray = (
      Index,
      key,
      table,
      newValue
    ) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...detailObj };

      updatedheadertestObj.Minimum_Leak_Path[0][table][Index][key] = newValue;
      setdetailObj(updatedheadertestObj);
    };

    const handleChangedetail = (e, i) => {
      setIsEdited(true);
      const { name, value } = e.target;

      setdetailObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const [valueNotes, setValueNotes] = useState("");

    const handleChangeNotes = (e) => {
      handleChangeNotesFlexible(e, {
        setIsEdited,
        setStateObj: setdetailObj,
        setValueNotes,
        maxNewLines: 2,
        maxLineLength: 45
      });
    };

    return (
      <fieldset disabled={isDisabled}>
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <Row className="font">
          <WPQHeader headerObj={headerObj}></WPQHeader>
          <Row style={{ padding: "20px 60px" }}>
            <Row className="mb-1">
              <p className="WPS-blue-text " style={{ position: "relative", top: "10px" }}>
                Minimum Leak Path{" "}
              </p>
              <Col md={6}>
                <PQRPage3TableColumnNindex
                  columns={5}
                  maxLength={[3, 4, 4, 4, 4]}
                  width={245}
                  width1={245}
                  width2={245}
                  width3={245}
                  array={Minimum_Leak_Path1}
                  setheaderObj={setheaderObj}
                  setError={setError}
                  name={["WPQ_MLP_Tube_No", "WPQ_MLP_LocA", "WPQ_MLP_LocB", "WPQ_MLP_LocC", "WPQ_MLP_LocD"]}
                  table="Table1"
                  index={0}
                  title={["Tube No.", "Loc A", "Loc B", "Loc C", "Loc D"]}
                  numberofrowsdisabled={0}
                  status={[error.WPQ_MLP_Tube_No.status, error.WPQ_MLP_LocA.status, error.WPQ_MLP_LocB.status, error.WPQ_MLP_LocC.status, error.WPQ_MLP_LocD.status]}
                  message={[error.WPQ_MLP_Tube_No.message, error.WPQ_MLP_LocA.message, error.WPQ_MLP_LocB.message, error.WPQ_MLP_LocC.message, error.WPQ_MLP_LocD.message]}
                  handleChangetestarray={handleChangeMinimum_Leak_Patharray}
                />
              </Col>
              <Col md={6}>
                <PQRPage3TableColumnNindex
                  columns={5}
                  maxLength={[3, 4, 4, 4, 4]}
                  width={245}
                  width1={245}
                  width2={245}
                  width3={245}
                  array={Minimum_Leak_Path2}
                  setheaderObj={setheaderObj}
                  setError={setError}
                  name={["WPQ_MLP_Tube_No", "WPQ_MLP_LocA", "WPQ_MLP_LocB", "WPQ_MLP_LocC", "WPQ_MLP_LocD"]}
                  table="Table2"
                  index={0}
                  title={["Tube No.", "Loc A", "Loc B", "Loc C", "Loc D"]}

                  numberofrowsdisabled={0}
                  status={[error.WPQ_MLP_Tube_No.status, error.WPQ_MLP_LocA.status, error.WPQ_MLP_LocB.status, error.WPQ_MLP_LocC.status, error.WPQ_MLP_LocD.status]}
                  message={[error.WPQ_MLP_Tube_No.message, error.WPQ_MLP_LocA.message, error.WPQ_MLP_LocB.message, error.WPQ_MLP_LocC.message, error.WPQ_MLP_LocD.message]}
                  handleChangetestarray={handleChangeMinimum_Leak_Patharray}
                />
              </Col>
            </Row>
            {/* ////////////////////////3nd table ////////////////////////////////////////////*/}
            <Row>
              <Col md={6} style={{ height: "215px" }}>
                <PQRPage3TableColumnNindex
                  columns={2}
                  array={Minimum_Leak_Path5}
                  setheaderObj={setheaderObj}
                  setError={setError}
                  name={["WPQ_MLP_Magnification", "WPQ_MLP_Acceptance_Criteria"]}
                  title={["Magnification", "Acceptance Criteria"]}
                  table="Table5"
                  status={[error.WPQ_MLP_Magnification.status, error.WPQ_MLP_Acceptance_Criteria.status]}
                  message={[error.WPQ_MLP_Magnification.message, error.WPQ_MLP_Acceptance_Criteria.message]}
                  width={[10, 10]}
                  handleChangetestarray={handleChangeMinimum_Leak_Patharray5}
                  maxLength={[16, 11]}
                />
              </Col>
              <Col md={6} style={{ height: "215px" }}>
                <WPQPage3Table3observation
                  setheaderObj={setheaderObj}
                  setError={setError}
                  name3="WPQ_MLP_Observation"
                  table="Table5"
                  value3={detailObj?.WPQ_MLP_Observation}
                  status2={error.WPQ_MLP_Observation.status}
                  message2={error.WPQ_MLP_Observation.message}
                  handleChangetestarray={handleChangeNotes}
                  maxLength3={180}
                  valueNotes={valueNotes}
                />
              </Col>
            </Row>
          </Row>
          <Row
            style={{
              padding: "0px 60px",
              position: "relative",
              bottom: "20px",
            }}
          >
            <span className="WPS-blue-text" style={{ position: "relative", right: "11px", top: "10px" }}>
              Result
            </span>
            <Row className="mb-1">
              <Col md={12}>
                <div className="T-input w-100">
                  <input
                    type="text"
                    id="WPQ_MLP_Result"
                    name="WPQ_MLP_Result"
                    maxLength={60}
                    placeholder=" "
                    value={detailObj?.WPQ_MLP_Result}
                    onChange={handleChangedetail}
                    onInput={(e) => {
                      let error = isAlphanumericWithPlusAmpersandEqualsPercentMinus(
                        e.target.value
                      );
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_MLP_Result: error,
                      }));
                    }}
                  />
                  <Form.Label htmlFor="WPQ_MLP_Result">Result</Form.Label>
                </div>
                {error.WPQ_MLP_Result.status && (
                  <Form.Text className="text-danger">
                    {error.WPQ_MLP_Result.message}
                  </Form.Text>
                )}
              </Col>
            </Row>
          </Row>
          <Row
            style={{
              padding: "20px 60px",
              position: "relative",
              bottom: "30px",
            }}
          >
            <Row className="mb-1">
              <Col md={12}>
                <p
                  className="WPS-blue-text "
                  style={{ position: "relative", top: "10px" }}
                >
                  Radiography Test{" "}
                </p>
                <PQRPage3TableColumnN
                  columns={4}
                  maxLength={[21, 13, 14, 21]}
                  width={[200, 120, 120, 180]}
                  session="WPQ"
                  array={Radiography_Test}
                  setheaderObj={setheaderObj}
                  numberofrowsdisabled={0}
                  setError={setError}
                  title={[
                    "Tube No.",
                    "Acceptance Criteria",
                    "Results",
                    "Remark",
                  ]}
                  name={[
                    "WPQ_Radio_TubeNo",
                    "WPQ_Radio_Acceptance_Criteria",
                    "WPQ_Radio_Observation",
                    "WPQ_Radio_Results",
                  ]}
                  status={[
                    error.WPQ_Radio_TubeNo.status,
                    error.WPQ_Radio_Acceptance_Criteria.status,
                    error.WPQ_Radio_Observation.status,
                    error.WPQ_Radio_Results.status,
                  ]}
                  message={[
                    error.WPQ_Radio_TubeNo.message,
                    error.WPQ_Radio_Acceptance_Criteria.message,
                    error.WPQ_Radio_Observation.message,
                    error.WPQ_Radio_Results.message,
                  ]}
                  handleChangetestarray={handleChangetestarray}
                />
              </Col>
              <span
                className="WPS-blue-text"
                style={{ position: "relative", top: "10px" }}
              >
                Notes
              </span>
              <Col md={12}>
                <SingleInput
                  disabled={isDisabled}
                  name="WPQ_Radio_Notes"
                  type="text"
                  // style={{ height: "100px" }}
                  maxLength={80}
                  status={error.WPQ_Radio_Notes.status}
                  value={detailObj?.WPQ_Radio_Notes}
                  onChange={handleChangedetail}
                  label="Notes"
                  message={error.WPQ_Radio_Notes.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="&±+-=%"
                  customMessage="Special Characters # + $ ' < >  ; not allowed"
                ></SingleInput>
              </Col>
            </Row>
          </Row>
          <Row
            style={{ padding: "20px 60px", position: "relative" }}>
            <Row className="mb-1">
              <Col md={12}>
                <p className="WPS-blue-text " style={{ position: "relative", top: "10px" }}>                  Other Test{" "}
                </p>
                <PQRPage3TableColumnN
                  columns={4}
                  maxLength={[21, 13, 14, 21]}
                  width={[200, 120, 120, 180]}
                  session="WPQ"
                  array={Other_Test}
                  setheaderObj={setheaderObj}
                  numberofrowsdisabled={0}
                  setError={setError}
                  title={[
                    "Type of Test",
                    "Acceptance Criteria",
                    "Results",
                    "Remark",
                  ]}
                  name={[
                    "WPQ_OT_TypeofTest",
                    "WPQ_OT_Acceptance_Criteria",
                    "WPQ_OT_Observation",
                    "WPQ_OT_Results",
                  ]}
                  status={[
                    error.WPQ_OT_TypeofTest.status,
                    error.WPQ_OT_Acceptance_Criteria.status,
                    error.WPQ_OT_Observation.status,
                    error.WPQ_OT_Results.status,
                  ]}
                  message={[
                    error.WPQ_OT_TypeofTest.message,
                    error.WPQ_OT_Acceptance_Criteria.message,
                    error.WPQ_OT_Observation.message,
                    error.WPQ_OT_Results.message,
                  ]}
                  handleChangetestarray={handleChangeOther_Testarray}
                />
              </Col>
              <span
                className="WPS-blue-text"
                style={{ position: "relative", top: "10px" }}
              >
                Notes
              </span>
              <Col md={12}>
                <SingleInput
                  disabled={isDisabled}
                  name="WPQ_OT_Notes"
                  type="text"
                  // style={{ height: "100px" }}
                  maxLength={80}
                  status={error.WPQ_OT_Notes.status}
                  value={detailObj?.WPQ_OT_Notes}
                  onChange={handleChangedetail}
                  label="Notes"
                  message={error.WPQ_OT_Notes.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="&±+-=%"
                  customMessage="Special Characters # + $ ' < >  ; not allowed"
                ></SingleInput>
              </Col>
            </Row>

            {/* -------------------------signature sections (unified component)---------------------------- */}
            <UnifiedSignatureSection
              sessionType="WPQ"
              sectionType="combined"
              headerObj={headerObj}
              setheaderObj={setheaderObj}
              users={users}
              error={error}
              setError={setError}
              previewImage={previewuser}
              previewApprovedImage={previewapproved}
              fetchUserProfile={fetchbyuserprofile}
              fetchApprovedUserProfile={fetchapproveUserProfile}
              isReadonly={isReadonly}
              isDisabled={isDisabled}
              action={action}
              setIsEdited={setIsEdited}
              Band={Band}
              handleChange={handleChange}
              handleChangeRadio={handleChangeRadio}
            />
          </Row>
        </Row>
      </fieldset>
    );
  }
);

export default WPQ_Tubesheet_Page4;